import { css } from "styled-components";

import hapiHero from "@/assets/images/achievements/hapi-hero.svg";
import holder from "@/assets/images/achievements/holder.webp";
import trader from "@/assets/images/achievements/trader.webp";
import villager from "@/assets/images/achievements/villager.webp";
import winner from "@/assets/images/achievements/winner.webp";
import { T_ME_HAPI_ANN } from "@/constants";
import { AchievementType } from "@/interfaces/api";
import { ButtonActionMap } from "@/services/config/translation";
import { colors } from "@/theme/colors";

export const getLevelStyles = (level: "disabled" | number) => {
  switch (level) {
    case 1:
    case 2:
    case 3:
    case 4: {
      return css`
        path {
          fill: ${colors.achievements.levels[level].background};
          stroke: ${colors.achievements.levels[level].border};
          &:first-of-type {
            stroke: ${colors.achievements.levels[level].boxShadow};
          }
        }
      `;
    }

    default:
      return css`
        path {
          fill: ${colors.achievements.levels.disabled.background};
          stroke: ${colors.achievements.levels.disabled.border};
          &:first-of-type {
            stroke: ${colors.achievements.levels.disabled.boxShadow};
          }
        }
      `;
  }
};

export const achievementMap: Record<AchievementType, string> = {
  holder: holder,
  villager: villager,
  trader: trader,
  winner: winner,
  hapiHero: hapiHero,
};

export const hapiAchievementActionMap: Record<number, { title: ButtonActionMap; handler: () => void }> = {
  1: { title: "JoinNow", handler: () => window.open(T_ME_HAPI_ANN) },
  4: {
    title: "Buy",
    handler: () =>
      window.parent.postMessage(
        {
          navigate: "/swaps?to=1010:d9c2d319cd7e6177336b0a9c93c21cb48d84fb54.factory.bridge.near",
        },
        "*",
      ),
  },
};
